/**
 * 获取本地存储
 */
export const getStorage = (key) => {
  if (!key) {
    return false;
  }
  return JSON.parse(window.localStorage.getItem(key));
}
/**
 * 设置本地存储
 */
export const setStorage = (key, value) => {
  if (!key && !value) {
    return false;
  }
  value = JSON.stringify(value);
  window.localStorage.setItem(key, value);
}
/**
 * 移除本地存储
 */
export const removeStorage = (key) => {
  if (!key) {
    return false;
  }
  return window.localStorage.removeItem(key);
}
/**
 * 获取临时存储
 */
export const getSession = (key) => {
  if (!key) {
    return false;
  }
  return JSON.parse(window.sessionStorage.getItem(key));
}
/**
 * 设置临时存储
 */
export const setSession = (key, value) => {
  if (!key && !value) {
    return false;
  }
  value = JSON.stringify(value);
  window.sessionStorage.setItem(key, value);
}
/**
 * 移除临时存储
 */
export const removeSession = (key) => {
  if (!key) {
    return false;
  }
  return window.sessionStorage.removeItem(key);
}

/**
 * 解析URL
 */
export const parseURL = (urlString) => {
  var url = urlString.toString()
  var a = document.createElement('a');
  a.href = url;
  return {
    source: url,
    protocol: a.protocol.replace(':', ''),
    host: a.hostname,
    port: a.port,
    query: a.search,
    file: (a.pathname.match(/\/([^\/?#]+)$/i) || [, ''])[1],
    hash: a.hash.replace('#', ''),
    path: a.pathname.replace(/^([^\/])/, '/$1'),
    relative: (a.href.match(/tps?:\/\/[^\/]+(.+)/) || [, ''])[1],
    segments: a.pathname.replace(/^\//, '').split('/'),
    params: (function () {
      var ret = {};
      var seg = a.search.replace(/^\?/, '').split('&').filter(function (v, i) {
        if (v !== '' && v.indexOf('=')) {
          return true;
        }
      });
      seg.forEach(function (element, index) {
        var idx = element.indexOf('=');
        var key = element.substring(0, idx);
        var val = element.substring(idx + 1);
        ret[key] = val;
      });
      return ret;
    })()
  };
}

/**
 * 获取style样式
 */
export const getStyle = (element, attr, NumberMode = 'int') => {
  let target;
  // scrollTop 获取方式不同，没有它不属于style，而且只有document.body才能用
  if (attr === 'scrollTop') {
    target = element.scrollTop;
    return NumberMode == 'float' ? parseFloat(target) : parseInt(target);
  }
  if (window.getComputedStyle) {
    //大部分高版本的浏览器支持的方法
    try {
      target = window.getComputedStyle(element, null)[attr];
    } catch (err) {
    }
  } else {
    //IE支持的方法
    target = element.currentStyle[attr];
  }
  //在获取 opactiy 时需要获取小数 parseFloat
  return NumberMode == 'float' ? parseFloat(target) : parseInt(target);
}

/**
 * 显示返回顶部按钮，开始、结束、运动 三个过程中调用函数判断是否达到目标点
 */
export const showBack = callback => {
  let requestFram;
  let oldScrollTop;

  document.addEventListener('scroll', () => {
    showBackFun();
  }, false)
  document.addEventListener('touchstart', () => {
    showBackFun();
  }, {passive: true})

  document.addEventListener('touchmove', () => {
    showBackFun();
  }, {passive: true})

  document.addEventListener('touchend', () => {
    oldScrollTop = document.body.scrollTop;
    moveEnd();
  }, {passive: true})

  const moveEnd = () => {
    if (window.requestAnimationFrame && window.cancelAnimationFrame) {
      requestFram = requestAnimationFrame(() => {
        if (document.body.scrollTop != oldScrollTop) {
          oldScrollTop = document.body.scrollTop;
          moveEnd();
        } else {
          cancelAnimationFrame(requestFram);
        }
        showBackFun();
      })
    } else {
      requestFram = setTimeout(() => {
        if (document.body.scrollTop != oldScrollTop) {
          oldScrollTop = document.body.scrollTop;
          moveEnd();
        } else {
          clearTimeout(requestFram);
        }
        showBackFun();
      }, 16)
    }

  }

  //判断是否达到目标点
  const showBackFun = () => {
    if (document.body.scrollTop > 500) {
      callback(true);
    } else {
      callback(false);
    }
  }
}

/**
 * base64编码
 */
export const base64 = function (str) {
  var base64EncodeChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
  var base64DecodeChars = new Array(-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 62, -1, -1, -1, 63, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, -1, -1, -1, -1, -1, -1, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, -1, -1, -1, -1, -1, -1, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, -1, -1, -1, -1, -1);
  var out, i, len;
  var c1, c2, c3;
  len = str.length;
  i = 0;
  out = "";
  while (i < len) {
    c1 = str.charCodeAt(i++) & 0xff;
    if (i == len) {
      out += base64EncodeChars.charAt(c1 >> 2);
      out += base64EncodeChars.charAt((c1 & 0x3) << 4);
      out += "==";
      break;
    }
    c2 = str.charCodeAt(i++);
    if (i == len) {
      out += base64EncodeChars.charAt(c1 >> 2);
      out += base64EncodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xF0) >> 4));
      out += base64EncodeChars.charAt((c2 & 0xF) << 2);
      out += "=";
      break;
    }
    c3 = str.charCodeAt(i++);
    out += base64EncodeChars.charAt(c1 >> 2);
    out += base64EncodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xF0) >> 4));
    out += base64EncodeChars.charAt(((c2 & 0xF) << 2) | ((c3 & 0xC0) >> 6));
    out += base64EncodeChars.charAt(c3 & 0x3F);
  }
  return out;
}


/**
 * 运动效果
 * @param {HTMLElement} element   运动对象，必选
 * @param {JSON}        target    属性：目标值，必选
 * @param {number}      duration  运动时间，可选
 * @param {string}      mode      运动模式，可选
 * @param {function}    callback  可选，回调函数，链式动画
 */
export const animate = (element, target, duration = 400, mode = 'ease-out', callback) => {
  clearInterval(element.timer);

  //判断不同参数的情况
  if (duration instanceof Function) {
    callback = duration;
    duration = 400;
  } else if (duration instanceof String) {
    mode = duration;
    duration = 400;
  }

  //判断不同参数的情况
  if (mode instanceof Function) {
    callback = mode;
    mode = 'ease-out';
  }

  //获取dom样式
  const attrStyle = attr => {
    if (attr === "opacity") {
      return Math.round(getStyle(element, attr, 'float') * 100);
    } else {
      return getStyle(element, attr);
    }
  };

  //根字体大小，需要从此将 rem 改成 px 进行运算
  const rootSize = parseFloat(document.documentElement.style.fontSize);
  const unit = {};
  const initState = {};

  //获取目标属性单位和初始样式值
  Object.keys(target).forEach(attr => {
    if (/[^\d^\.]+/gi.test(target[attr])) {
      unit[attr] = target[attr].match(/[^\d^\.]+/gi)[0] || 'px';
    } else {
      unit[attr] = 'px';
    }
    initState[attr] = attrStyle(attr);
  });

  //去掉传入的后缀单位
  Object.keys(target).forEach(attr => {
    if (unit[attr] == 'rem') {
      target[attr] = Math.ceil(parseInt(target[attr]) * rootSize);
    } else {
      target[attr] = parseInt(target[attr]);
    }
  });

  let flag = true; //假设所有运动到达终点
  const remberSpeed = {};//记录上一个速度值,在ease-in模式下需要用到
  element.timer = setInterval(() => {
    Object.keys(target).forEach(attr => {
      let iSpeed = 0;  //步长
      let status = false; //是否仍需运动
      let iCurrent = attrStyle(attr) || 0; //当前元素属性址
      let speedBase = 0; //目标点需要减去的基础值，三种运动状态的值都不同
      let intervalTime; //将目标值分为多少步执行，数值越大，步长越小，运动时间越长
      switch (mode) {
        case 'ease-out':
          speedBase = iCurrent;
          intervalTime = duration * 5 / 400;
          break;
        case 'linear':
          speedBase = initState[attr];
          intervalTime = duration * 20 / 400;
          break;
        case 'ease-in':
          let oldspeed = remberSpeed[attr] || 0;
          iSpeed = oldspeed + (target[attr] - initState[attr]) / duration;
          remberSpeed[attr] = iSpeed
          break;
        default:
          speedBase = iCurrent;
          intervalTime = duration * 5 / 400;
      }
      if (mode !== 'ease-in') {
        iSpeed = (target[attr] - speedBase) / intervalTime;
        iSpeed = iSpeed > 0 ? Math.ceil(iSpeed) : Math.floor(iSpeed);
      }
      //判断是否达步长之内的误差距离，如果到达说明到达目标点
      switch (mode) {
        case 'ease-out':
          status = iCurrent != target[attr];
          break;
        case 'linear':
          status = Math.abs(Math.abs(iCurrent) - Math.abs(target[attr])) > Math.abs(iSpeed);
          break;
        case 'ease-in':
          status = Math.abs(Math.abs(iCurrent) - Math.abs(target[attr])) > Math.abs(iSpeed);
          break;
        default:
          status = iCurrent != target[attr];
      }

      if (status) {
        flag = false;
        //opacity 和 scrollTop 需要特殊处理
        if (attr === "opacity") {
          element.style.filter = "alpha(opacity:" + (iCurrent + iSpeed) + ")";
          element.style.opacity = (iCurrent + iSpeed) / 100;
        } else if (attr === 'scrollTop') {
          element.scrollTop = iCurrent + iSpeed;
        } else {
          element.style[attr] = iCurrent + iSpeed + 'px';
        }
      } else {
        flag = true;
      }

      if (flag) {
        clearInterval(element.timer);
        if (callback) {
          callback();
        }
      }
    })
  }, 20);
}

/**
 *  bridge 与app交互的公共方法
 */
export const setupWebViewJavascriptBridge = (callback) => {
  if (window.WebViewJavascriptBridge) {
    callback(WebViewJavascriptBridge)
  } else {
    document.addEventListener(
      'WebViewJavascriptBridgeReady'
      , function () {
        callback(WebViewJavascriptBridge)
      },
      false
    );
  }

  if (window.WVJBCallbacks) {
    return window.WVJBCallbacks.push(callback);
  }
  window.WVJBCallbacks = [callback];
  let WVJBIframe = document.createElement('iframe');
  WVJBIframe.style.display = 'none';
  WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__';
  document.documentElement.appendChild(WVJBIframe);
  setTimeout(function () {
    document.documentElement.removeChild(WVJBIframe)
  }, 0)
}

// 保留两个小数
export const twoPoint = (num => {
  const a = num * 1;
  const b = a.toFixed(2);
  return b;
})
// 保留两个小数，并获取到小数点前面的
export const twoPointPre = (num => {
  const a = num * 1;
  const b = a.toFixed(2) + '';
  return b.split('.')[0];
})
// 保留两个小数，并获取到小数点后面的
export const twoPointNext = (num => {
  const a = num * 1;
  const b = a.toFixed(2) + '';
  return b.split('.')[1];
})
// 超出99 显示99+
export const hundred = (num => {
  if (num > 99) {
    return '99+';
  } else {
    return num;
  }
})

// 图片过滤，加上私有后缀 300*240
export const half = (imgurl => {
  if (!imgurl) {
    return '/static/img/nophotos.22dee75.png';
  }
  imgurl += '-linhuiba_half?v=1';
  return imgurl;
})

// 图片过滤，加上私有后缀 180*180
export const small = (imgurl => {
  if (!imgurl) {
    return '/static/img/nophotos.22dee75.png';
  }
  imgurl += '-linhuiba_thumbnail?v=1';
  return imgurl;
})

// 图片过滤，加上私有后缀 600*480
export const large = (imgurl => {
  if (!imgurl) {
    return '/static/img/nophotos.22dee75.png';
  }
  imgurl += '-linhuiba_watermark?v=1';
  return imgurl;
})
// 图片没有时，默认给上 nophoto.png
export const nophoto = (imgurl => {
  if (!imgurl) {
    return '/static/img/nophotos.22dee75.png';
  }
})


// 去掉空格
export const trim = (val => {
  if (!val) {
    return;
  }
  return val.replace(/^\s*|\s*$/, "");
})
// 时间格式化
export const timeFormat = (time => {
  if (!time) {
    return;
  }
  return time.replace(/-/gi, '.');
})

// 场地规格*号换成x
export const normFormat = (norm => {
  if (!norm) {
    return;
  }
  return norm.replace(/\*/gi, 'x');
})
// 把秒转化成小时
export const ssTohh = (hour => {
  if (hour > 0) {
    let h = '';
    let number = 0;
    if (hour > 3600) {
      number = parseInt(hour / 3600);
      h = number + '小时';
    } else if (hour >= 60) {
      number = parseInt(hour / 60);
      h = number + '分钟';
    } else {
      h = hour + '秒';
    }
    return h;
  }
})



/**
 * html反编码
 * 转义符 参考 http://114.xixik.com/character/
 */
export const htmlDecode = (text) => {
  var temp = "";
  if (!text||text.length == 0) return "";
  temp = text.replace(/&amp;/g, "&").replace(/&amp;/g, "&");
  temp = temp.replace(/&lt;/g, "<");
  temp = temp.replace(/&gt;/g, ">");
  temp = temp.replace(/&nbsp;/g, " ");
  temp = temp.replace(/&#39;/g, "\'");
  temp = temp.replace(/&quot;/g, "\"");
  temp = temp.replace(/&amp;nbsp;/g, "、");
  temp = temp.replace(/<\/?.+?\/?>/g, '');
  temp=temp.replace(/&ldquo;/g,"“").replace(/&rdquo;/g,"”");
  temp=temp.replace(/&lsquo;/g,"‘").replace(/&rsquo;/g,"’");
  temp=temp.replace(/&plusmn;/g,"±").replace(/&beta;/g,"β").replace(/&hellip;/g,"…").replace(/&rarr;/g,"→").replace(/&mdash;/g,"—");
  return temp;
}

// 根据身份证获取年龄
export const getAgeByIdcard = (idcard) => {
  if (!idcard || (idcard.length !== 15 && idcard.length !== 18))//身份证号码只能为15位或18位其它不合法
  {
    return 0;
  }

  var strBirthday = "";
  if (idcard.length == 18)//处理18位的身份证号码从号码中得到生日和性别代码
  {
    strBirthday = idcard.substr(6, 4) + "/" + idcard.substr(10, 2) + "/" + idcard.substr(12, 2);
  }
  if (idcard.length == 15) {
    strBirthday = "19" + idcard.substr(6, 2) + "/" + idcard.substr(8, 2) + "/" + idcard.substr(10, 2);
  }
  //时间字符串里，必须是“/”
  var birthDate = new Date(strBirthday);
  var nowDateTime = new Date();
  var age = nowDateTime.getFullYear() - birthDate.getFullYear();
  //再考虑月、天的因素;.getMonth()获取的是从0开始的，这里进行比较，不需要加1
  if (nowDateTime.getMonth() < birthDate.getMonth() || (nowDateTime.getMonth() == birthDate.getMonth() && nowDateTime.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
}


// 根据身份证获取性别
export const getSexByIdcard = (idcard) => {
  if (!idcard || (idcard.length !== 15 && idcard.length !== 18))//身份证号码只能为15位或18位其它不合法
  {
    return '未知';
  }
  let sex = idcard.length === 18 ? idcard.substr(14, 3) : idcard.substr(12, 3);
  //性别代码为偶数是女性奇数为男性
  return parseInt(sex) % 2 === 0 ? "女" : "男";

}

export const getAgeByBirth=(strBirthday)=>{
  if(!strBirthday){
    return 0;
  }
    //时间字符串里，必须是“/”
    strBirthday = strBirthday.split(' ')[0];
    var birthDate = new Date(Date.parse(strBirthday.replace(/-/g, "/")));
    var nowDateTime = new Date();
    var age = nowDateTime.getFullYear() - birthDate.getFullYear();
    //再考虑月、天的因素;.getMonth()获取的是从0开始的，这里进行比较，不需要加1
    if (nowDateTime.getMonth() < birthDate.getMonth() || (nowDateTime.getMonth() == birthDate.getMonth() && nowDateTime.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
}



export const getMemberInfo = (success, error) => {
  common.ajax({
    transNO: 'SG0018',
    params: {
      member_num: common.getStorage('member_num'),
      access_token: common.getStorage('access_token'),
    }
  }).then(res => {
    if (res.ret_code === '0') {
      common.setStorage('idcard', res.member.idcard);
      common.setStorage('name', res.member.name['#cdata-section'] || res.member.name);
      common.setStorage('phone', res.member.phone);
      common.setStorage('login_name', res.member.login_name['#cdata-section'] || res.member.login_name);
      common.setStorage('treatment_card', res.member.treatment_card);
      common.setStorage('address', res.member.address);
      success();
    } else {
      error(res);
    }
  })
}

/* 校验身份证号  */
export const checkIdCard = (id) => {
  var flag = true;
  //转换大小写
  id = id.toUpperCase();
  var arrVerifyCode = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];
  var Wi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
  var Checker = [1, 9, 8, 7, 6, 5, 4, 3, 2, 1, 1];
  if(id.length != 15 && id.length != 18) {
    console.log('身份证号不符合规则')
    flag = false;
  }
  var Ai = id.length == 18 ? id.substring(0, 17) : id.slice(0, 6) + "19" + id.slice(6, 16);
  if(!/^\d+$/.test(Ai)) {
    console.log('身份证号不符合规则')
    flag = false;
  }
  var yyyy = Ai.slice(6, 10),
    mm = Ai.slice(10, 12) - 1,
    dd = Ai.slice(12, 14);
  var d = new Date(yyyy, mm, dd),
    now = new Date();
  var year = d.getFullYear(),
    mon = d.getMonth(),
    day = d.getDate();
  if(year != yyyy || mon != mm || day != dd || d > now || year < 1800) {
    console.log('身份证号不符合规则')
    flag = false;
  }
  for(var i = 0, ret = 0; i < 17; i++) {
    ret += Ai.charAt(i) * Wi[i]
  }
  Ai += arrVerifyCode[ret %= 11];
  if(id.length == 18 && id != Ai) {
    console.log('身份证号不符合规则')
    flag = false;
  }
  return flag;
}



//////////////////
// WEBPACK FOOTER
// ./static/js/tools.js
// module id = MRgP
// module chunks = 16